import React from "react";

const Footer = () => {
  return (
    <footer>
      <h3>// SKILL_HUNT</h3>
    </footer>
  );
};

export default Footer;
